import userService from '../../services/user.service';
import {
  APPLICATION_REFRESH_DATE,
  APP_INIT_DEFERRED,
  APP_IS_READY,
  AUTH_LOGIN,
  AUTH_UPDATE_TOKEN,
  CONTACTS_CREATE,
  CONTACTS_DELETE,
  CONTACTS_UPDATE_CONTACT,
  ORGANIZATION_SWITCH,
  ORGANIZATION_UPDATE,
} from '../actions';
import { fetchContacts } from '../actions/contacts.actions';

export const contactsFetchDataMiddleware =
  ({ dispatch, getState }) =>
  next =>
  async action => {
    next(action);

    // `fetchContacts` silently skips while the organization slice (and its
    // feature list) hasn't loaded — so the boot-time triggers below can all
    // fire too early on a slow load, and search results then drop contact
    // hits forever. Do the initial fetch when the organization actually
    // arrives, but ONLY the initial one: unconditional ORGANIZATION_UPDATE
    // refetching is what PLT-3302 removed.
    const isInitialOrgLoad =
      action.type === ORGANIZATION_UPDATE && !getState().contacts?.contactsById;

    if (
      action.type === AUTH_LOGIN ||
      action.type === APP_IS_READY ||
      // Retry after deferred init — mirrors users-management.middleware.
      action.type === APP_INIT_DEFERRED ||
      isInitialOrgLoad ||
      action.type === AUTH_UPDATE_TOKEN ||
      action.type === APPLICATION_REFRESH_DATE ||
      action.type === ORGANIZATION_SWITCH ||
      action.type === CONTACTS_CREATE ||
      action.type === CONTACTS_UPDATE_CONTACT ||
      action.type === CONTACTS_DELETE
    ) {
      if (!userService.isAuthenticated) return false;

      dispatch(fetchContacts());
    }
  };

export const contactsMiddleware = [contactsFetchDataMiddleware];
